import React from 'react';

interface ExpandedImageModalProps {
    imageUrl: string;
    onClose: () => void;
}

export default function ExpandedImageModal({ imageUrl, onClose }: ExpandedImageModalProps) {
    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-95 z-[100] flex items-center justify-center p-4"
            onClick={onClose}
        >
            {/* Expanded Image Container */}
            <div className="relative max-w-4xl max-h-full w-full">
                <img
                    src={imageUrl}
                    alt="Contact Profile"
                    className="w-full h-auto rounded-lg shadow-2xl max-h-[95vh] object-contain mx-auto"
                    onClick={(e) => e.stopPropagation()} // Prevent closing when clicking image
                />
                {/* Close button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 w-12 h-12 bg-black bg-opacity-80 text-white rounded-full flex items-center justify-center hover:bg-opacity-90 transition-all duration-200 text-xl font-light"
                >
                    ×
                </button>
            </div>
        </div>
    );
}
